import React from 'react';
import { useOnboarding } from '../contexts/OnboardingContext';

export default function OnboardingEntryScreen() {
  const { entryVisible, start, skip } = useOnboarding();
  if (!entryVisible) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      backgroundColor: 'rgba(0,0,0,0.55)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        background: 'white', borderRadius: 16, maxWidth: 520, width: '100%',
        padding: '40px 40px 36px', boxShadow: '0 25px 60px rgba(0,0,0,0.22)',
      }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>✈️</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#111', margin: '0 0 10px' }}>
          Welkom bij TravelAIgent
        </h2>
        <p style={{ color: '#6b7280', fontSize: 14, margin: '0 0 24px', lineHeight: 1.65 }}>
          We begeleiden u stap voor stap zodat uw AI-assistent optimaal werkt voor uw reisbureau.
        </p>

        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {[
            'Importeer bestaande reisdocumenten en informatie',
            'Stel de toon en instructies van uw AI-assistent in',
            'Bekijk korte instructievideo\'s over de belangrijkste functies',
          ].map((benefit, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: '#374151' }}>
              <span style={{ color: '#2563eb', fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
              {benefit}
            </li>
          ))}
        </ul>

        <div style={{
          background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8,
          padding: '10px 14px', marginBottom: 28,
          display: 'flex', alignItems: 'center', gap: 8,
          fontSize: 13, color: '#0369a1',
        }}>
          <span>⏱</span>
          <span>Geschatte tijd: <strong>10–15 minuten</strong></span>
        </div>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={start}
            style={{
              flex: 1, padding: '12px 20px',
              background: 'var(--brand, #2563eb)', color: 'white',
              border: 'none', borderRadius: 8, fontWeight: 600,
              fontSize: 14, cursor: 'pointer',
            }}
          >
            Onboarding starten
          </button>
          <button
            onClick={skip}
            style={{
              padding: '12px 20px', background: 'transparent',
              color: '#6b7280', border: '1px solid #e5e7eb',
              borderRadius: 8, fontWeight: 500, fontSize: 14, cursor: 'pointer',
            }}
          >
            Overslaan
          </button>
        </div>
      </div>
    </div>
  );
}
